import { render, staticRenderFns } from "./OccurrenceDisplay.vue?vue&type=template&id=30a70b4e&scoped=true&"
import script from "./OccurrenceDisplay.vue?vue&type=script&lang=js&"
export * from "./OccurrenceDisplay.vue?vue&type=script&lang=js&"
import style0 from "./OccurrenceDisplay.vue?vue&type=style&index=0&id=30a70b4e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30a70b4e",
  null
  
)

export default component.exports